import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/icons/gestor-versiones-alt.svg")